module.exports = __webpack_public_path__ + "img/si.482961e6.svg";